<template>
  <v-row justify="center">
    <v-col cols="12">
      <!-- Botón para registrar ingreso -->
      <PrimaryButton @click="dialog = true">Registrar ingreso</PrimaryButton>
    </v-col>
    <!-- Contenedor de el botón -->
    <v-dialog v-model="dialog" persistent max-width="600px">
      <!-- Modal -->
      <v-card v-if="!isLoading">
        <!-- Título -->
        <v-card-title>
          <p class="headline font-weight-bold mb-0">Registra un ingreso</p>
        </v-card-title>
        <v-card-text class="mb-0 pb-0">
          <!-- Formulario -->
          <v-container fluid class="pa-0">
            <p class="subtitle-2 text-hint mb-1 mt-2">SUCURSAL DEL INGRESO</p>
            <!-- Sucursales -->
            <v-row class="ml-0 mr-0">
              <v-flex xs12 class="mb-0 pb-0">
                <v-select
                  v-model="selectedBranch"
                  :items="branches"
                  return-object
                  item-text="name"
                  item-value="_id"
                  label="Sucursal del ingreso"
                  no-data-text="No hay sucursales disponibles"
                  filled
                  rounded
                  dense
                ></v-select>
              </v-flex>
            </v-row>
            <p class="subtitle-2 text-hint mb-2 mt-0">DATOS DEL INGRESO</p>
            <!-- Datos del ingreso -->
            <v-row class="ml-0 mr-0">
              <!-- importe-->
              <v-flex xs12>
                <TextField
                  min="0"
                  type="number"
                  class="mb-4"
                  placeholder="Importe"
                  v-model="amount"
                />
              </v-flex>
              <!-- Descripcion-->
              <v-flex xs12>
                <TextField
                  class="mb-5"
                  placeholder="Descripción"
                  v-model="description"
                />
              </v-flex>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="reset">Cancelar</v-btn>
          <v-btn color="primary" text @click="createIncome">Guardar</v-btn>
        </v-card-actions>
      </v-card>
      <!-- Tarjeta si está cargando -->
      <v-card v-else align="center" justify="center">
        <v-progress-circular class="mt-12 mb-4" indeterminate color="primary" />
        <v-card-text class="text-center pb-12">
          Estamos registrando el ingreso
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
// importar componentes
const PrimaryButton = () => import("@/components/PrimaryButton");
const TextField = () => import("@/components/TextField");

// Importar servicios
import BranchesServices from "@/services/BranchesServices";
import MovementsServices from "@/services/MovementsServices";

// Importar dependencias
import { mapGetters } from "vuex";

export default {
  name: "create-income",
  components: {
    TextField,
    PrimaryButton
  },
  data() {
    return {
      dialog: false,
      isLoading: false,
      amount: "",
      description: "",
      branches: [],
      selectedBranch: {}
    };
  },
  created: async function() {
    // Obtenemos todas las sucursales
    try {
      // Obtener sucursales
      this.branches = await BranchesServices.getBranchesInUserProfile();
      // Validamos si solo tiene una sucursal, para ponerla como default
      if (this.branches.length === 1) {
        this.selectedBranch = this.branches[0];
      }
    } catch (err) {
      // Emitir el error
      this.$emit("income-error", err.message);
    }
  },
  computed: {
    ...mapGetters(["getProfile"]),
    areFieldsComplete: function() {
      return !!this.selectedBranch && !!this.description && !!this.amount;
    }
  },
  // obtenemos los productos de esa sucursal
  methods: {
    createIncome: async function() {
      // Verificamos que esten todos los campos rellenos
      if (!this.areFieldsComplete) {
        this.$emit("income-error", "Rellena los campos necesarios, por favor");
        return;
      }

      // Formamos el objeto con los nuevos campos
      const newIncome = {};

      // Agregamos el id del negocio
      newIncome["businessId"] = this.getProfile.business_id;
      // Agregamos el id de la sucursal
      newIncome["branchId"] = this.selectedBranch._id;
      // Agregamos el importe
      newIncome["amount"] = this.amount;
      // Agregamos la descripción
      newIncome["description"] = this.description;

      // Crear ingreso
      try {
        // Mostrar spinner
        this.isLoading = true;

        // Realizamos la petición
        const income = await MovementsServices.createIncome(newIncome);

        // Enviar evento a mixpanel
        this.$mixpanel.track("new-income", {
          distinct_id: this.getProfile.business_id,
          total: income.amount
        });

        // Vaciamos los campos y cerramos el dialogo
        this.reset();

        // Recargamos la página
        this.$emit("update-income");

        // Ocultar spinner
        this.isLoading = false;
      } catch (err) {
        // Mostrar spinner
        this.isLoading = false;
        // Emitir evento con el error
        this.$emit("income-error", err.message);
      }
    },
    reset: function() {
      // Vaciamos los campos
      this.amount = "";
      this.description = "";

      if (this.branches.length > 1) {
        this.selectedBranch = {};
      }

      // Cerramos el dialogo
      this.dialog = false;
    }
  }
};
</script>

<style scoped></style>
